// extracted by mini-css-extract-plugin
export default {"container":"styles_container__m0LlA","image":"styles_image__rPfMn"};